import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Cotizacion from './Cotizacion';
import $ from 'jquery';
import { regresar, getCotizacion } from './reducer/todo-reducer';

class Tipo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            disabledUniversidad: false,
            tipo: "18",
            cotizacion: {
                "cotizacion": {
                    "primaBasica": "80676.0",
                    "primaBeneficios": "3780.0",
                    "edadCotizacion": "49",
                    "coberturas": {
                        "coberturas": [
                            {
                                "cobertura": "",
                                "sumaAsegurada": "",
                                "prima": ""
                            },
                            {
                                "cobertura": "0000001076",
                                "sumaAsegurada": "900000.0",
                                "prima": "126.0"
                            },
                            {
                                "cobertura": "0000001393",
                                "sumaAsegurada": "900000.0",
                                "prima": "657.0"
                            },
                            {
                                "cobertura": "0000001394",
                                "sumaAsegurada": "900000.0",
                                "prima": "2997.0"
                            }
                        ]
                    },
                    "primaTotal": "8458.93125"
                },
                "ahorroGarantizado": 900000
            },
            loading: false
        }
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.successCotizacion) {
            console.log(nextProps.successCotizacion);
        }
    }

    componentDidMount() {
        $(window).scrollTop(0);
        if (this.props.valores.edadHijo >= 12) {
            this.setState({ disabledUniversidad: true });
            this.setState({ tipo: "23" })
        }
    }

    render() {

        console.log("successCotizacion" + this.props.successCotizacion);

        if (this.props.successCotizacion) {
            return <Cotizacion cotizacion={this.props.successCotizacion} />
        }

        return (
            <div style={{ maxWidth: "570px", margin: "auto auto" }}>
                <div className="backCotizacionEducacionPaso2Desktop hidden-xs">
                    <div className="divTituloEducacion">
                        <label className="iconoCotDesktop" />
                        <label className="requiredIn labelTituloDesktop" >Asegura la colegiatura de tus hijos</label>
                    </div>

                    <div className="col-xs-12 text-center hidden-xs">
                        <label className="labelTeGustari"></label>
                    </div>

                    <div className="radioUni">
                        <input type="radio" name="tipoDesk" value="18"
                            onChange={this.changeValues.bind(this)} checked={this.state.tipo === "18"}
                            disabled={this.state.disabledUniversidad} />
                    </div>

                    <div className="radioMaes">
                        <input type="radio" name="tipoDesk" value="23"
                            onChange={this.changeValues.bind(this)} checked={this.state.tipo === "23"} />
                    </div>

                    <div className="textUni">
                        <label></label>
                    </div>

                    <div className="textMaes">
                        <label></label>
                    </div>

                    <div className="edadUni">
                        <label></label>
                    </div>

                    <div className="edadMaes">
                        <label></label>
                    </div>


                </div>

                <div className="col-xs-12 text-right hidden-xs" style={{ maxWidth: "570px" }}>
                    <button className="btn btn-return" onClick={this.regresar.bind(this)}>Regresar</button>&nbsp;&nbsp;&nbsp;&nbsp;
                    <button className="btn btn-gnp" onClick={this.cotizar.bind(this)}>Continuar</button>
                </div>

                <div className="formulario-cotiza hidden-md hidden-sm hidden-lg">
                    <div className="titulo">
                        <label className="iconoCotResponsive" />
                        <label>Asegura la colegiatura de tu hijos</label>
                    </div>
                    <div className="contenidoFormulario">
                        <div className="col-xs-12 text-center eleccionTipo">
                            <p>Te gustaría generar un ahorro<br /> para apoyarlo en:</p>
                        </div>



                        <div className="col-xs-12">
                            <div className="col-xs-6 text-center">
                                <label className="uniResponsive" ></label>
                                <br />
                                <input type="radio" name="tipo" id="tipo" value="18" className="browser-default"
                                    onChange={this.changeValues.bind(this)} checked={this.state.tipo === "18"}
                                    disabled={this.state.disabledUniversidad}
                                /> <label>Universidad</label>
                                <div className="descripcionTipo">
                                    (18 años)
                                </div>
                            </div>
                            <div className="col-xs-6 text-center">
                                <label className="maestResponsive" ></label>
                                <br />
                                <input type="radio" name="tipo" id="tipo" value="23" className="browser-default"
                                    onChange={this.changeValues.bind(this)} checked={this.state.tipo === "23"}

                                /> <label>Maestría</label>
                                <div className="descripcionTipo">
                                    (23 años)
                                </div>
                            </div>

                        </div>

                        <div className="col-xs-12 text-center" style={{ marginTop: "20px" }}>
                            <button className="btn btn-return" onClick={this.regresar.bind(this)}>Regresar</button>&nbsp;&nbsp;&nbsp;&nbsp;
                            <button className="btn btn-gnp" onClick={this.cotizar.bind(this)}>Continuar</button>

                        </div>

                    </div>

                </div>


                {
                    this.state.loading ?
                        <div className="gnp-loading">
                            <div className="circle-orange"></div>
                            <div className="circle-blue"></div>
                            <div className="logo"><img src="https://storage.googleapis.com/static-portalcorporativo.gnp.com.mx/images/site/logo_header @1x.svg"
                                className="fr-fic fr-dib" /></div>
                        </div>
                        : null
                }

            </div>
        )
    }

    changeValues(event) {
        var name = event.target.name;
        var value = event.target.value;

        if (name === "tipoDesk") {
            name = "tipo";
        }

        this.setState({ [name]: value });
    }

    regresar(event) {

        console.log("Regresa Tpo");
        console.log(this.props.valores);
        console.log(this.state);
        window.location.reload();

    }

    cotizar(event) {
        console.log(this.props.valores);
        console.log(this.state);

        var values = {
            edadApoyo: this.state.tipo,
            paso1: {
                nombre: this.props.valores.nombre,
                apellido: this.props.valores.apellidos,
                correo: this.props.valores.correo,
                tTelefono: this.props.valores.tTelefono,
                telefono: this.props.valores.telefono,
                edadHijo: this.props.valores.edadHijo,
                montoMensual: this.props.valores.monto,
                edad: this.props.valores.cmbEdad,
                genero: this.props.valores.genero,
                habito: this.props.valores.habito
            }
        }

        this.setState({ loading: true });
        this.props.actions.getCotizacion(values);
    }

}
const mapStateToProps = (state) => {
    return {
        successCotizacion: state.educacionReducer.get("successCotizacion")
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({ regresar: regresar, getCotizacion: getCotizacion }, dispatch)
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Tipo);



// WEBPACK FOOTER //
// ./src/Tipo.js